export type ModalidadeCurso = 'PRESENCIAL' | 'SEMIPRESENCIAL' | 'TOTAL_EAD' | 'AO_VIVO' | 'FLEX_ESPECIAL';

export const modalidadesFormatadas: Record<ModalidadeCurso, string> = {
  PRESENCIAL: 'Presencial',
  SEMIPRESENCIAL: 'Semipresencial',
  TOTAL_EAD: 'Total EAD',
  AO_VIVO: 'Ao Vivo',
  FLEX_ESPECIAL: 'Flex Especial',
};
